document.addEventListener("DOMContentLoaded", function () {
  if (typeof Shopify === "undefined") return;

  const configElement = document.querySelector('[data-ndd-config]');
  if (!configElement) return;

  const config = JSON.parse(configElement.textContent);
  if (!config || !config.display_ndd_messaging) return;

  const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

  // --- Get current UK time (handles BST automatically) ---
  function getUKNow() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false
    });

    const parts = formatter.formatToParts(now);
    const map = {};
    parts.forEach(p => map[p.type] = parseInt(p.value));

    return new Date(
      map.year,
      map.month - 1, // JS months are 0-indexed
      map.day,
      map.hour,
      map.minute,
      map.second,
      0
    );
  }

  // --- Hide all NDD messages ---
  function removeAllShowNdd() {
    document.querySelectorAll(".product__stock-and-delivery, [data-delivery-info]").forEach(el => {
      el.classList.remove("show-ndd", "delivery-info--ndd");
    });
    document.querySelectorAll("[data-ndd], [data-delivery-ndd], .ndd").forEach(el => {
      el.innerHTML = "";
    });
  }

  // --- Get today's config ---
  function getTodayConfig(now) {
    const today = weekdays[now.getDay()]; // 0=Sunday, 1=Monday, ...
    return config.display_ndd_messaging.find(d => d.day === today);
  }

  // --- Convert HH:MM to UK Date today ---
  function createUKDate(now, timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date(now);
    date.setHours(hours, minutes, 0, 0); // local UK time
    return date;
  }

  // --- Start countdown ---
  function startNddCountdown() {
    const now = getUKNow();
    const todayConfig = getTodayConfig(now);

    if (!todayConfig || (todayConfig.from_time === "00:00" && todayConfig.until_time === "00:00")) {
      removeAllShowNdd();
      return;
    }

    const start = createUKDate(now, todayConfig.from_time);
    const end = createUKDate(now, todayConfig.until_time);

    // Hide immediately if outside window
    if (now < start || now >= end) {
      removeAllShowNdd();
      return;
    }

    function updateCountdown() {
      const now = getUKNow();
      const diff = end - now;

      if (diff <= 0) {
        removeAllShowNdd();
        clearInterval(interval);
        return;
      }

      const totalMinutes = Math.ceil(diff / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      document.querySelectorAll("[data-ndd], [data-delivery-ndd], .ndd").forEach(el => {
        // Copy comes from the language file via data attributes; the fallback keeps templates
        // that don't render them (the legacy PDP) exactly as before.
        const template = el.dataset.nddText || "Order in <b>[hours]h [minutes]m</b> for <b>Next Day Delivery</b>";
        let html = template.replace("[hours]", hours).replace("[minutes]", minutes);
        if (el.dataset.nddNote) {
          html += `<span class="delivery-info__ndd-note">${el.dataset.nddNote}</span>`;
        }
        el.innerHTML = html;
      });
    }

    const interval = setInterval(updateCountdown, 500);
    updateCountdown();
  }

  startNddCountdown();
});
